import type {
  ConnectionConfig,
  ActionBindingConfig,
  BehaviorBindingConfig,
  BindingConfig,
  ExpressionBindingConfig,
  FieldBindingConfig,
  FilterBindingConfig,
  TotalCountBindingConfig,
} from '@wix/wix-data-client-types'
import { get, map } from 'lodash'

export const parseBindings = ({
  properties,
  events,
  behaviors,
  userInputFilter,
  totalCount,
  expressions,
}: ConnectionConfig = {}): BindingConfig[] => {
  const fieldBindings: FieldBindingConfig[] = map(
    properties,
    ({ fieldName, format, linkTarget, linkRel }, prop) => ({
      type: 'Field',
      prop,
      fieldPath: fieldName,
      format: get(format, 'params.dateFormat'),
      linkTarget,
      linkRel,
    }),
  )

  const actionBindings: ActionBindingConfig[] = map(
    events,
    ({ action, postAction }, event) => ({
      type: 'Action',
      event,
      action,
      postAction,
    }),
  )
  const behaviorBindings: BehaviorBindingConfig[] = map(
    behaviors,
    behavior => ({
      type: 'Behavior',
      behavior: behavior.type,
    }),
  )

  const filterBinding: FilterBindingConfig | FilterBindingConfig[] =
    userInputFilter
      ? {
          type: 'Filter',
          fieldPath: userInputFilter.fieldName,
          prop: userInputFilter.prop,
          condition: userInputFilter.condition,
        }
      : []

  const totalCountBinding: TotalCountBindingConfig | TotalCountBindingConfig[] =
    totalCount
      ? {
          type: 'TotalCount',
          prop: totalCount.prop,
        }
      : []

  const expressionBindings: ExpressionBindingConfig[] = map(
    expressions,
    ({ expression }, prop) => ({
      type: 'Expression',
      prop,
      expression,
    }),
  )

  return (fieldBindings as BindingConfig[])
    .concat(behaviorBindings)
    .concat(actionBindings)
    .concat(filterBinding)
    .concat(expressionBindings)
    .concat(totalCountBinding)
}
